import React, { useEffect, useState } from "react";
import { Form, Row, Col, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { generateReportCard, } from "../../store/slices/result";
import { toast } from "react-hot-toast";
import { FiHome, FiChevronRight } from "react-icons/fi";
import { fetchStandardSection } from "../../store/slices/getstandardsection";
import { getStudent } from "../../store/slices/student";
import { getExam } from "../../store/slices/exam";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default function Result() {
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();
  const [errors, setErrors] = useState({});
  const sessions = Array.from({ length: 2 }, (_, index) => {
    const startYear = currentYear - 1 + index;
    const endYear = String(startYear + 1).slice(-2);

    return `${startYear}-${endYear}`;
  });

  const [session, setSession] = useState("");
  const [standardId, setStandardId] = useState("");
  const [studentId, setStudentId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);

  const [standards, setStandards] = useState([]);
  const [students, setStudents] = useState([]);
  const [sections, setSections] = useState([]);

  const [examId, setExamId] = useState("");
  const [exams, setExams] = useState([]);
  const [feeDetails, setFeeDetails] = useState([]);


  useEffect(() => {
    dispatch(getExam())
      .unwrap()
      .then((res) => {
        setExams(res.data || []);
      })
      .catch((err) => {
        toast.error(err);
      });
  }, [dispatch]);
  useEffect(() => {

    dispatch(fetchStandardSection())
      .unwrap()
      .then((res) => {

        setStandards(res.data || []);

      })
      .catch((err) => {

        toast.error(err);

      });

  }, []);


  const validate = () => {
    const newErrors = {};

    if (!session) {
      newErrors.session = "Please select session";
    }

    if (!standardId) {
      newErrors.standardId = "Please select standard";
    }

    if (!sectionId) {
      newErrors.sectionId = "Please select section";
    }
    if (!examId) {
      newErrors.examId = "Please select exam";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleStandardChange = (e) => {

    const value = e.target.value;

    setStandardId(value);

    setSectionId("");

    setStudentId("");

    setStudents([]);

    setFeeDetails([]);

    const selectedStandard = standards.find(
      item => item.standardId._id === value
    );

    if (selectedStandard) {
      setSections(selectedStandard.sectionId);
    } else {
      setSections([]);
    }

  };

  const handleSectionChange = (e) => {

    const value = e.target.value;

    setSectionId(value);

    setStudentId("");

    setFeeDetails([]);

    dispatch(getStudent({
      standardId,
      sectionId: value
    }))
      .unwrap()
      .then((res) => {

        setStudents(res.data || []);

      })
      .catch((err) => {

        toast.error(err);

      });

  };

  const handleStudentChange = (e) => {

    setStudentId(e.target.value);

    setFeeDetails([]);

  };
  const replacePlaceholders = (template, report) => {

    let html = template;

    const student = report?.student || {};
    const standard = report?.standard || {};
    const section = report?.section || {};
    const exam = report?.exam || {};

    const subjectsHtml = (report?.subjects || [])
      .map((subject, index) => {

        const displayedValue =
          subject?.displayMarks ??
          subject?.obtainedMarks ??
          "-";

        const grade = String(displayedValue)
          .trim()
          .toUpperCase();

        const obtainedMarks = Number(subject?.obtainedMarks);
        const passMarks = Number(subject?.passMarks);

        const isFailed =
          grade === "C" || grade === "AB" ||
          (
            Number.isFinite(obtainedMarks) &&
            Number.isFinite(passMarks) &&
            obtainedMarks < passMarks
          );

        return `
                <tr class="result-row">

                    <td>
                        ${index + 1}
                    </td>

                    <td class="subject">
                        ${subject?.subjectName ?? "-"}
                    </td>

                    <td class="max-mark">
                        ${subject?.maxMarks ?? "-"}
                    </td>

                    <td class="min-mark">
                        ${subject?.passMarks ?? "-"}
                    </td>

               <td
    class="obtained-value"
    style="${isFailed
            ? "color: red !important; font-weight: 600;"
            : ""
          }"
>
    ${displayedValue}
</td>

                    <td class="std-stat">
                        ${subject?.standardHighest ?? "-"}
                    </td>

                    <td class="sec-stat">
                        ${subject?.sectionHighest ?? "-"}
                    </td>

                    <td class="std-stat">
                        ${subject?.standardAverage ?? "-"}
                    </td>

                    <td class="sec-stat">
                        ${subject?.sectionAverage ?? "-"}
                    </td>

                </tr>
            `;

      })
      .join("");


    const values = {

      examName:
        exam?.name ?? "-",

      session:
        report?.session ?? "-",

      studentName:
        student?.name ?? "-",

      classSection:
        `${standard?.name ?? "-"} / ${section?.name ?? "-"}`,

      rollNo:
        student?.rollNumber ??
        student?.rollNo ??
        "-",

      attendance:
        report?.attendance ??
        student?.attendance ??
        "-",

      stdStrength:
        report?.stdStrength ?? "-",

      secStrength:
        report?.secStrength ?? "-",

      subjects:
        subjectsHtml,

      totalMax:
        report?.totalMaxMarks ?? "-",

      totalMin:
        report?.totalPassMarks ?? "-",

      totalObtained:
        report?.totalObtainedMarks ?? "-",

      stdHighest:
        report?.standardHighest ?? "-",

      secHighest:
        report?.sectionHighest ?? "-",

      stdAverage:
        report?.standardAverage ?? "-",

      secAverage:
        report?.sectionAverage ?? "-"
    };


    Object.entries(values).forEach(
      ([key, value]) => {

        html = html.replace(
          new RegExp(`{{${key}}}`, "g"),
          String(value ?? "")
        );

      }
    );


    return html;
  };

  const handleSearch = async (e) => {

    e?.preventDefault();

    if (!validate()) return;

    setIsGenerating(true);


    const payload = {
      session,
      standardId,
      sectionId,
      examId
    };


    if (studentId) {
      payload.studentId = studentId;
    }


    try {

      const response = await dispatch(
        generateReportCard(payload)
      ).unwrap();

      const data = response?.data;


      if (!data) {

        throw new Error(
          "Report card data not found."
        );

      }


      const {
        template,

        reports: apiReports,

        paperSize = "A3",

        orientation = "portrait",


      } = data;


      const reports = Array.isArray(apiReports)
        ? apiReports
        : apiReports
          ? [apiReports]
          : [];
      if (!template) {

        throw new Error(
          "Report card template not found."
        );

      }


      if (
        !reports ||
        reports.length === 0
      ) {

        throw new Error(
          "No report cards found."
        );

      }


      const styleMatches = [
        ...template.matchAll(
          /<style[^>]*>([\s\S]*?)<\/style>/gi
        )
      ];


      const templateStyles =
        styleMatches
          .map(
            match => match[1]
          )
          .join("\n");

      let reportsHtml = "";

      reports.forEach((report) => {

        const generatedHtml =
          replacePlaceholders(
            template,
            report
          );

        const bodyMatch =
          generatedHtml.match(
            /<body[^>]*>([\s\S]*?)<\/body>/i
          );

        const body =
          bodyMatch
            ? bodyMatch[1]
            : generatedHtml;

        reportsHtml += `

        <div class="report-card-page">

            ${body}

        </div>

    `;

      });

      const pdfContainer =
        document.createElement("div");


      const paperSizes = {

        A3: {
          width: 1123,
          height: 1587
        },

        A4: {
          width: 794,
          height: 1123
        },

        A5: {
          width: 559,
          height: 794
        }

      };

      const selectedPaper =
        paperSizes[String(paperSize).toUpperCase()] ||
        paperSizes.A4;


      let pageWidth = selectedPaper.width;
      let pageHeight = selectedPaper.height;


      // Landscape
      if (
        String(orientation).toLowerCase() === "landscape"
      ) {

        [pageWidth, pageHeight] =
          [pageHeight, pageWidth];

      }


      pdfContainer.innerHTML = `

    <style>

        ${templateStyles}

        html,
        body {

            margin: 0 !important;
            padding: 0 !important;

            background: #ffffff;

        }

        .report-card-page {

            width: ${pageWidth}px !important;

            min-width: ${pageWidth}px !important;

            max-width: ${pageWidth}px !important;

            min-height: ${pageHeight}px !important;

            box-sizing: border-box;

            background: #ffffff;

            position: relative;

            overflow: hidden;

            margin: 0;

            padding: 0;

            page-break-before: auto;

            page-break-after: auto;

            break-before: auto;

            break-after: auto;

        }
  .result-row td {
    font-size: 18px !important;
    padding-top: 5px !important;
    padding-bottom: 5px !important;
    line-height: 1.3 !important;
}

    </style>

    ${reportsHtml}

`;

      pdfContainer.style.position = "absolute";
      pdfContainer.style.left = "-100000px";
      pdfContainer.style.top = "0";
      pdfContainer.style.width = `${pageWidth}px`;
      pdfContainer.style.backgroundColor = "#ffffff";
      pdfContainer.style.zIndex = "-1";

      document.body.appendChild(pdfContainer);


      await new Promise(resolve => {

        requestAnimationFrame(() => {

          requestAnimationFrame(resolve);

        });

      });


      try {

        const pdf = new jsPDF({

          orientation:
            String(orientation).toLowerCase(),

          unit: "mm",

          format:
            String(paperSize).toLowerCase(),

          compress: true

        });


        const reportPages =
          pdfContainer.querySelectorAll(
            ".report-card-page"
          );


        console.log(
          "Report cards to generate:",
          reportPages.length
        );

        for (
          let index = 0;
          index < reportPages.length;
          index++
        ) {

          const reportPage =
            reportPages[index];


          // Make sure browser has rendered it
          await new Promise(resolve => {

            requestAnimationFrame(() => {

              requestAnimationFrame(resolve);

            });

          });

          const canvas =
            await html2canvas(
              reportPage,
              {

                scale: 2,

                useCORS: true,

                allowTaint: false,

                backgroundColor: "#ffffff",

                logging: false,

                scrollX: 0,

                scrollY: 0,

                width: pageWidth,

                height: pageHeight,

                windowWidth: pageWidth,

                windowHeight: pageHeight

              }
            );


          const imgData =
            canvas.toDataURL(
              "image/jpeg",
              0.95
            );

          const pdfWidth =
            pdf.internal.pageSize.getWidth();

          const pdfHeight =
            pdf.internal.pageSize.getHeight();


          if (index > 0) {

            pdf.addPage();

          }


          pdf.addImage(

            imgData,

            "JPEG",

            0,

            0,

            pdfWidth,

            pdfHeight,

            undefined,

            "FAST"

          );

        }


        pdf.save(
          `Report-Card-${session}.pdf`
        );


      } finally {

        pdfContainer.remove();

      }


    } catch (err) {

      console.error(
        "REPORT CARD ERROR:",
        err
      );

      toast.error(
        err?.message ||
        "Failed to generate report card"
      );

    } finally {

      setIsGenerating(false);

    }

  };

  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">
          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/accounts/home">
                <FiHome style={{ color: "white", marginTop: "-4px" }} />
              </Link>
            </div>



            <FiChevronRight className="separator" />

            <span className="active">Report Card</span>
          </div>
        </div>
      </div>
      <div className="acs-card">
        <Form onSubmit={handleSearch}>
          <Row className="g-3">

            {/* Session */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Session</Form.Label>
                <Form.Select
                  value={session}

                  onChange={(e) => {
                    setSession(e.target.value);
                    setErrors((prev) => ({
                      ...prev,
                      session: "",
                    }));
                  }}
                >
                  <option value="">Select Session</option>

                  {sessions.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </Form.Select>

                {errors.session && (
                  <div className="text-danger mt-1">{errors.session}</div>
                )}
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Exam</Form.Label>

                <Form.Select
                  value={examId}
                  onChange={(e) => {
                    setExamId(e.target.value);
                    setErrors((prev) => ({
                      ...prev,
                      examId: "",
                    }));
                  }}
                >
                  <option value="">Select Exam</option>

                  {exams.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>

                {errors.examId && (
                  <div className="text-danger mt-1">
                    {errors.examId}
                  </div>
                )}
              </Form.Group>
            </Col>

            {/* Standard */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Standard</Form.Label>

                <Form.Select
                  value={standardId}

                  onChange={(e) => {
                    handleStandardChange(e);

                    setErrors((prev) => ({
                      ...prev,
                      standardId: "",
                    }));
                  }}
                >
                  <option value="">Select Standard</option>

                  {standards.map((item) => (
                    <option
                      key={item.standardId._id}
                      value={item.standardId._id}
                    >
                      {item.standardId.name}
                    </option>
                  ))}
                </Form.Select>

                {errors.standardId && (
                  <div className="text-danger mt-1">
                    {errors.standardId}
                  </div>
                )}
              </Form.Group>
            </Col>
            {/* Exam */}

            {/* Section */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Section</Form.Label>

                <Form.Select
                  value={sectionId}
                  disabled={!standardId}

                  onChange={(e) => {
                    handleSectionChange(e);

                    setErrors((prev) => ({
                      ...prev,
                      sectionId: "",
                    }));
                  }}
                >
                  <option value="">Select Section</option>

                  {sections.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>

                {errors.sectionId && (
                  <div className="text-danger mt-1">
                    {errors.sectionId}
                  </div>
                )}
              </Form.Group>
            </Col>

            {/* Student */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Student</Form.Label>
                <Form.Select
                  value={studentId}
                  disabled={!sectionId}

                  onChange={(e) => {
                    handleStudentChange(e);
                    setErrors((prev) => ({
                      ...prev,
                      studentId: "",
                    }));
                  }}
                >
                  <option value="">All Student</option>

                  {students.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>


              </Form.Group>
            </Col>

          </Row>

          <Row className="mt-5">
            <Col className="d-flex justify-content-center">
              <button
                type="button"
                className="btn-submit"
                style={{ width: "150px" }}
                onClick={handleSearch}
                disabled={isGenerating}
              >
                {isGenerating ? "Generating..." : "Generate PDF"}
              </button>
            </Col>

          </Row>

          {feeDetails.length > 0 && (

            <div className="mt-4">

              {feeDetails.map((category) => (

                <div
                  key={category.feeCategoryId}
                  className="mb-5"
                >

                  <div className="table-responsive mt-5">

                    <Table className="staff-table align-middle">

                      <thead className="table-light">

                        <tr>

                          <th className="text-center">
                            Installment
                          </th>

                          <th className="text-center">
                            Due Date
                          </th>

                          <th className="text-center">
                            Amount
                          </th>

                          <th className="text-center">
                            Paid
                          </th>

                          <th className="text-center">
                            Discount
                          </th>

                          <th className="text-center">
                            Due
                          </th>

                          <th className="text-center">
                            Status
                          </th>




                        </tr>

                      </thead>

                      <tbody>

                        {category.installments.map((item, index) => (

                          <tr key={index}>

                            <td className="text-center">{item.installmentName}</td>

                            <td className="text-center">
                              {new Date(item.dueDate).toLocaleDateString()}
                            </td>

                            <td className="text-center">₹{item.amount}</td>

                            <td className="text-center">₹{item.paid}</td>

                            <td className="text-center">₹{item.discount}</td>

                            <td className="text-center">₹{item.due}</td>

                            <td className="text-center">

                              <span
                                className={
                                  item.status === "Paid"
                                    ? "badge bg-success"
                                    : item.status === "Partial"
                                      ? "badge bg-warning"
                                      : "badge bg-danger"
                                }
                              >
                                {item.status}
                              </span>

                            </td>


                          </tr>

                        ))}

                      </tbody>

                    </Table>

                  </div>

                </div>

              ))}

            </div>

          )}
        </Form>
      </div>
    </>
  );
}